export enum SmsMessageStatus {
    Pending = 'pending',
    Accepted = 'accepted',
    Sent = 'sent',
    Delivered = 'delivered',
    Undelivered = 'undelivered',
    Failed = 'failed',
}

export const FAILED_STATUSES: ReadonlySet<string> = new Set([
    SmsMessageStatus.Failed,
    SmsMessageStatus.Undelivered,
]);
